"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canShowChangePermissionOption = exports.getCFOEntityAccessTrackingProps = exports.hasDatasetFullAccess = exports.getItemAccessControl = exports.capitalizeString = exports.membersOptions = exports.stringAvatar = void 0;
const accountGroupUtils_1 = require("companion-app-components/flux/account-groups/accountGroupUtils");
const utils_1 = require("containers/App/Header/ProfileMenu/utils");
const themeUtils_1 = require("themes/themeUtils");
const stringAvatar = (name) => {
    const nameParts = name.split(' ');
    return {
        sx: {
            bgcolor: (0, themeUtils_1.applyOpacityToHex)((0, utils_1.stringToColor)(name), 0.6),
            fontSize: 16,
            width: 45,
            height: 45,
            color: 'shadowGrey',
            fontWeight: 500,
            textTransform: 'uppercase',
        },
        children: nameParts.length > 1
            ? `${nameParts[0][0]}${nameParts[1][0]}`
            : `${nameParts[0][0]}`,
    };
};
exports.stringAvatar = stringAvatar;
exports.membersOptions = [{
        label: 'Resend Invitation',
        action: 'resend',
        types: ['INVITED', 'ABANDONED'],
        eventName: 'resendInvitation',
    }, {
        label: 'Revoke Invitation',
        action: 'revoke',
        types: ['INVITED'],
        eventName: 'revokeInvitation',
    }, {
        label: 'Remove Member',
        action: 'remove',
        types: ['ACCEPTED', 'ACTIVE', 'ABANDONED'],
        eventName: 'removeAccess',
    }];
const capitalizeString = (str) => str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
exports.capitalizeString = capitalizeString;
const getItemAccessControl = (isCFOUser, fullAccess, read, write) => {
    if (!isCFOUser) {
        return undefined;
    }
    return {
        version: '1.0.0',
        resources: {
            ACCOUNT_GROUP: {
                write: fullAccess ? ['*'] : write,
                read: fullAccess ? ['*'] : read,
                delete: [],
            },
            Q17_ACCOUNT: {
                write: fullAccess ? ['*'] : write,
                read: fullAccess ? ['*'] : read,
                delete: [],
            },
        },
    };
};
exports.getItemAccessControl = getItemAccessControl;
const hasDatasetFullAccess = (_accountGroups, share) => {
    var _a, _b;
    if (!(share === null || share === void 0 ? void 0 : share.itemAccessControl)) {
        return true;
    }
    const sharedAccountGroupIds = (0, accountGroupUtils_1.deriveAccountGroupdIds)((_b = (_a = share === null || share === void 0 ? void 0 : share.itemAccessControl) === null || _a === void 0 ? void 0 : _a.resources) === null || _b === void 0 ? void 0 : _b.ACCOUNT_GROUP, ['write', 'read']);
    return sharedAccountGroupIds.length === 2
        && sharedAccountGroupIds.every((accountGroupId) => accountGroupId === '*');
};
exports.hasDatasetFullAccess = hasDatasetFullAccess;
const getCFOEntityAccessTrackingProps = (fullAccess, entityCount, read, write) => {
    const readLength = (read === null || read === void 0 ? void 0 : read.length) || 0;
    const writeLength = (write === null || write === void 0 ? void 0 : write.length) || 0;
    return {
        access_type: fullAccess ? 'full access' : 'custom access',
        entity_count: entityCount,
        entity_shared: readLength + writeLength,
        entity_view_shared: readLength,
        entity_edit_shared: writeLength,
    };
};
exports.getCFOEntityAccessTrackingProps = getCFOEntityAccessTrackingProps;
const canShowChangePermissionOption = (hasDatasetEntityPermissions, hasShareableAccountGroups, isOwnerViewingSharedDataset, shareState) => (hasDatasetEntityPermissions
    && hasShareableAccountGroups
    && isOwnerViewingSharedDataset
    && shareState !== 'ABANDONED');
exports.canShowChangePermissionOption = canShowChangePermissionOption;
